import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, hasRole } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, roles }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (roles && !hasRole(user, ...roles)) {
    return (
      <div className="p-8 text-center">
        <h2 className="text-2xl font-bold text-slate-900">Access Denied</h2>
        <p className="text-slate-600 mt-2">You don't have permission to view this page.</p>
      </div>
    );
  }
  return children;
};

export default ProtectedRoute;
